<template>
  <div>
    <div data-v-3db1efaa=""
         class="v-data-table elevation-1 v-data-table--fixed-header v-data-table--has-bottom theme--light"
         sortable="sortable">
      <div class="v-data-table__wrapper">
        <table>
          <colgroup>
            <col class="">
            <col class="">
            <col class="">
            <col class="">
            <col class="">
            <col class="">
            <col class="">
            <col class="">
            <col class="">
            <col class="">
            <col class="">
            <col class="">
          </colgroup>
          <thead data-v-a952ce2c="">
            <tr data-v-a952ce2c="">
              <th data-v-a952ce2c="" colspan="3" style="text-align: center;">
                Общее количество клиентов<span data-v-a952ce2c="" class="indicators_sum"> ({{ sumAmnt(data['М'], data['Ж'], data['Т']) }})</span>
              </th>
              <th data-v-a952ce2c="" colspan="3" style="text-align: center;">
                Новых клиентов<span data-v-a952ce2c="" class="indicators_sum"> ({{ sumAmnt(data['new_М'] , data['new_Ж'] , data['new_Т']) }})</span>
              </th>
              <th data-v-a952ce2c="" colspan="3" style="text-align: center;">
                Постоянных клиентов<span data-v-a952ce2c="" class="indicators_sum"> ({{ sumAmnt(data['constant_М'] , data['constant_Ж'] , data['constant_Т']) }})</span>
              </th>
              <th data-v-a952ce2c="" colspan="3" style="text-align: center;">
                {{ data['contacts_М'] }}
                {{ data['contacts_Ж'] }}
                {{ data['contacts_Т'] }}
                Контактов<span data-v-a952ce2c="" class="indicators_sum"> ({{ sumAmnt(data['contacts_М'] , data['contacts_Ж'] , data['contacts_Т']) }})</span>
              </th>
            </tr>
          </thead>
          <tr data-v-3db1efaa="" />
          <thead class="v-data-table-header">
            <tr>
              <th role="columnheader"
                  scope="col"
                  aria-label="Мужчин: Not sorted. Activate to sort ascending."
                  aria-sort="none"
                  class="text-center sortable">
                <span>Мужчин</span><i aria-hidden="true"
                                      class="v-icon notranslate v-data-table-header__icon mdi mdi-arrow-up theme--light"
                                      style="font-size: 18px;" />
              </th>
              <th role="columnheader"
                  scope="col"
                  aria-label="Женщин: Not sorted. Activate to sort ascending."
                  aria-sort="none"
                  class="text-center sortable">
                <span>Женщин</span><i aria-hidden="true"
                                      class="v-icon notranslate v-data-table-header__icon mdi mdi-arrow-up theme--light"
                                      style="font-size: 18px;" />
              </th>
              <th role="columnheader"
                  scope="col"
                  aria-label="Трансперсон: Not sorted. Activate to sort ascending."
                  aria-sort="none"
                  class="text-center sortable">
                <span>Трансперсон</span><i aria-hidden="true"
                                           class="v-icon notranslate v-data-table-header__icon mdi mdi-arrow-up theme--light"
                                           style="font-size: 18px;" />
              </th>
              <th role="columnheader"
                  scope="col"
                  aria-label="Мужчин: Not sorted. Activate to sort ascending."
                  aria-sort="none"
                  class="text-center sortable">
                <span>Мужчин</span><i aria-hidden="true"
                                      class="v-icon notranslate v-data-table-header__icon mdi mdi-arrow-up theme--light"
                                      style="font-size: 18px;" />
              </th>
              <th role="columnheader"
                  scope="col"
                  aria-label="Женщин: Not sorted. Activate to sort ascending."
                  aria-sort="none"
                  class="text-center sortable">
                <span>Женщин</span><i aria-hidden="true"
                                      class="v-icon notranslate v-data-table-header__icon mdi mdi-arrow-up theme--light"
                                      style="font-size: 18px;" />
              </th>
              <th role="columnheader"
                  scope="col"
                  aria-label="Трансперсон: Not sorted. Activate to sort ascending."
                  aria-sort="none"
                  class="text-center sortable">
                <span>Трансперсон</span><i aria-hidden="true"
                                           class="v-icon notranslate v-data-table-header__icon mdi mdi-arrow-up theme--light"
                                           style="font-size: 18px;" />
              </th>
              <th role="columnheader"
                  scope="col"
                  aria-label="Мужчин: Not sorted. Activate to sort ascending."
                  aria-sort="none"
                  class="text-center sortable">
                <span>Мужчин</span><i aria-hidden="true"
                                      class="v-icon notranslate v-data-table-header__icon mdi mdi-arrow-up theme--light"
                                      style="font-size: 18px;" />
              </th>
              <th role="columnheader"
                  scope="col"
                  aria-label="Женщин: Not sorted. Activate to sort ascending."
                  aria-sort="none"
                  class="text-center sortable">
                <span>Женщин</span><i aria-hidden="true"
                                      class="v-icon notranslate v-data-table-header__icon mdi mdi-arrow-up theme--light"
                                      style="font-size: 18px;" />
              </th>
              <th role="columnheader"
                  scope="col"
                  aria-label="Трансперсон: Not sorted. Activate to sort ascending."
                  aria-sort="none"
                  class="text-center sortable">
                <span>Трансперсон</span><i aria-hidden="true"
                                           class="v-icon notranslate v-data-table-header__icon mdi mdi-arrow-up theme--light"
                                           style="font-size: 18px;" />
              </th>
              <th role="columnheader"
                  scope="col"
                  aria-label="Мужчин: Not sorted. Activate to sort ascending."
                  aria-sort="none"
                  class="text-start sortable">
                <span>Мужчин</span><i aria-hidden="true"
                                      class="v-icon notranslate v-data-table-header__icon mdi mdi-arrow-up theme--light"
                                      style="font-size: 18px;" />
              </th>
              <th role="columnheader"
                  scope="col"
                  aria-label="Женщин: Not sorted. Activate to sort ascending."
                  aria-sort="none"
                  class="text-left sortable">
                <span>Женщин</span><i aria-hidden="true"
                                      class="v-icon notranslate v-data-table-header__icon mdi mdi-arrow-up theme--light"
                                      style="font-size: 18px;" />
              </th>
              <th role="columnheader"
                  scope="col"
                  aria-label="Трансперсон: Not sorted. Activate to sort ascending."
                  aria-sort="none"
                  class="text-center sortable">
                <span>Трансперсон</span><i aria-hidden="true"
                                           class="v-icon notranslate v-data-table-header__icon mdi mdi-arrow-up theme--light"
                                           style="font-size: 18px;" />
              </th>
            </tr>
          </thead>
          <tbody>
            <tr data-v-3db1efaa="" class="sortableRow">
              <!---->
              <td data-v-3db1efaa="" class="table-header-center">
                {{ data['М'] ? data['М'] : 0 }}
              </td>
              <td data-v-3db1efaa="" class="table-header-center">
                {{ data['Ж'] ? data['Ж'] : 0 }}
              </td>
              <td data-v-3db1efaa="" class="table-header-center">
                {{ data['Т'] ? data['Т'] : 0 }}
              </td>
              <td data-v-3db1efaa="" class="table-header-center">
                {{ data['new_М'] ? data['new_М'] : 0 }}
              </td>
              <td data-v-3db1efaa="" class="table-header-center">
                {{ data['new_Ж'] ? data['new_Ж'] : 0 }}
              </td>
              <td data-v-3db1efaa="" class="table-header-center">
                {{ data['new_Т'] ? data['new_Т'] : 0 }}
              </td>
              <td data-v-3db1efaa="" class="table-header-center">
                {{ data['constant_М'] ? data['constant_М'] : 0 }}
              </td>
              <td data-v-3db1efaa="" class="table-header-center">
                {{ data['constant_Ж'] ? data['constant_Ж'] : 0 }}
              </td>
              <td data-v-3db1efaa="" class="table-header-center">
                {{ data['constant_Т'] ? data['constant_Т'] : 0 }}
              </td>
              <td data-v-3db1efaa="" class="table-header-center">
                {{ data['contacts_М'] ? data['contacts_М'] : 0 }}
              </td>
              <td data-v-3db1efaa="" class="table-header-center">
                {{ data['contacts_Ж'] ? data['contacts_Ж'] : 0 }}
              </td>
              <td data-v-3db1efaa="" class="table-header-center">
                {{ data['contacts_Т'] ? data['contacts_Т'] : 0 }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
// import ReportTable from '../../ReportTable'

export default {
  name: "ReportIndicatorCustomers",

  // components: {ReportTable},
  props: {
    data: {
      type: [Array, Object],
      default: () => []
    },
    loading: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    pagination: {
      sortBy: 'name'
    },
    selected: [],
    isLoading: true
  }),
  methods: {
    sumAmnt (m, w, t) {
      let mv = m ? m : 0
      let wv = w ? w : 0
      let tw = t ? t : 0
      return mv + wv + tw
    }
  }
}
</script>


<style lang="scss" scoped>
.indicators_sum {
  color: rgb(25, 118, 210)
}
</style>



// WEBPACK FOOTER //
// src/components/reports/pages/indicators/ReportIndicatorCustomers.vue